import React, { useRef } from 'react';
import { CmAlertDialog } from '@codametrix/ui-components';
import { Button } from '../button/button';
import { ButtonVariant } from '../../core/enums';
import { CoderListSection } from '../coder-list-section/coder-list-section';
import { CoderListItemProps } from '../coder-list-item/coder-list-item';
import './manage-coders-modal.scss';

export interface ManageCodersModalProps {
  isOpen: boolean;
  queueName: string;
  assignedCoders: CoderListItemProps[];
  availableCoders: CoderListItemProps[];
  onSave: () => void;
  onCancel: () => void;
  saveDisabled?: boolean;
}

export const ManageCodersModal: React.FC<ManageCodersModalProps> = ({
  isOpen,
  queueName,
  assignedCoders,
  availableCoders,
  onSave,
  onCancel,
  saveDisabled = false
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  const footer = (
    <>
      <Button
        ref={cancelRef}
        label="Cancel"
        variant={ButtonVariant.SECONDARY}
        onClick={onCancel}
        dataTestId="manage-coders-cancel"
      />
      <Button
        label="Save Assignments"
        disabled={saveDisabled}
        onClick={onSave}
        dataTestId="manage-coders-save"
      />
    </>
  );

  return (
    <CmAlertDialog
      isOpen={isOpen}
      onClose={onCancel}
      title={`Manage Coders - ${queueName}`}
      leastDestructiveRef={cancelRef}
      footer={footer}
      variant="wide"
      contentTestId="manage-coders-modal"
    >
      <div className="cmx-manage-coders-modal">
        <p className="cmx-manage-coders-modal__subtitle">
          Add or remove coders from this queue. Coders must have the appropriate
          skill set to be assigned.
        </p>
        <div className="cmx-manage-coders-modal__sections">
          <CoderListSection
            title="Currently Assigned"
            coders={assignedCoders}
          />
          <CoderListSection title="Available Coders" coders={availableCoders} />
        </div>
      </div>
    </CmAlertDialog>
  );
};

ManageCodersModal.displayName = 'ManageCodersModal';
